import React from 'react';
import { CardMeta } from 'components/card-meta/CardMeta';
import s from './FileCard.scss';
import { ArrowButton } from 'components/arrow-button/ArrowButton';
import {
  PlaceholderColor,
  DefaultPlaceholderColor,
  IPlaceholderColors,
} from '../../types/placeholderColors';

interface IProps {
  heading: string;
  link?: string;
  meta?: string | React.ReactNode;
  linkText?: string;
  size?: 'large' | 'default';
  color?: PlaceholderColor;
}

export const FileCard = ({
  heading,
  link,
  meta,
  linkText,
  size = 'default',
  color = DefaultPlaceholderColor,
}: IProps) => {
  const colors: IPlaceholderColors = {
    purple: s.purple,
    black: s.black,
    'dark purple': s.purple30,
    grey: s.grey,
  };

  const backgroundColor = color.toLowerCase() in colors ? colors[color.toLowerCase()] : '';

  return (
    <div className={s('fileCard', backgroundColor, { large: size === 'large' })}>
      <h2 className={s.fileCard__heading}>{heading}</h2>
      <div className={s.fileCard__date}>{meta && <CardMeta className={s.fileCard__meta} date={meta} />}</div>
      
      {link && (
        <div className={s.fileCard__link}>
          <ArrowButton direction="forward" to={link}>
            {linkText}
          </ArrowButton>
        </div>
      )}
    </div>
  );
};
